import React from 'react';
import Navbar from './components/Navbar';
import HeroSlider from './components/HeroSlider';
import AboutSection from './components/AboutSection';
import Services from './components/Services';
import Team from './components/Team';
import StudyDestinations from './components/StudyDestinations';

import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />

      <main>
        <section id="home">
          <HeroSlider />
        </section>

        <section id="about">
          <AboutSection />
        </section>

        <section id="services">
          <Services />
        </section>

        <section id="team">
          <Team />
        </section>

        <section id="destinations">
          <StudyDestinations />
        </section>

        <section id="contact">
          <ContactForm />
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default App;
